export default "/images/ditforsikringshus.webp?ce9ec545ac072dce59197299470284b7";